import { createSlice } from '@reduxjs/toolkit';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

const initialState = {
  projects: [],
  searchQuery: '',
  filteredProjects: [],
  loading: false,
  error: null,
};

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    setProjects: (state, action) => {
      state.projects = action.payload;
      state.filteredProjects = action.payload;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
      if (action.payload.trim() === '') {
        state.filteredProjects = state.projects;
      } else {
        const query = action.payload.toLowerCase();
        state.filteredProjects = state.projects.filter(
          (project) =>
            project.name.toLowerCase().includes(query) ||
            (project.clientName &&
              project.clientName.toLowerCase().includes(query))
        );
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setProjects, setSearchQuery, setLoading, setError } =
  projectsSlice.actions;

// Thunk action creator for creating a project
export const createProject = (projectData) => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true));
    const docRef = await addDoc(collection(db, 'projects'), {
      ...projectData,
      createdAt: new Date(),
      createdBy: projectData.createdBy || null,
    });
    const newProject = { id: docRef.id, ...projectData };
    const currentProjects = getState().projects.projects;
    dispatch(setProjects([...currentProjects, newProject]));
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setError(error.message));
    dispatch(setLoading(false));
    throw error;
  }
};

export default projectsSlice.reducer;
